export default "__VITE_ASSET__RA78Y9Nl__"